import { render } from "./ListAttributeMasters.vue?vue&type=template&id=72f13f46"
import script from "./ListAttributeMasters.vue?vue&type=script&lang=js"
export * from "./ListAttributeMasters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__